export const API_URL = process.env.REACT_APP_API_URL;
export const UPLOADS_URL = process.env.REACT_APP_UPLOADS_URL;
export const JWT_SECRET = "fi8bfk3ikfuk3urf93uf3uh3fuh";
